import { createActionCreator } from 'deox';

import { TGetLicenseOverviewMaterials, TLicenseOverviewResponse } from '@/services/api/company';

// CONSTANTS

export enum EGetLicenseOverviewAction {
  GET_LICENSE_OVERVIEW = 'GET_LICENSE_OVERVIEW',
  GET_LICENSE_OVERVIEW_REQUEST = 'GET_LICENSE_OVERVIEW_REQUEST',
  GET_LICENSE_OVERVIEW_SUCCESS = 'GET_LICENSE_OVERVIEW_SUCCESS',
  GET_LICENSE_OVERVIEW_FAILED = 'GET_LICENSE_OVERVIEW_FAILED',
}

// TYPES

export type TGetLicenseOverviewRequest = {
  type: EGetLicenseOverviewAction.GET_LICENSE_OVERVIEW_REQUEST;
  payload: {
    materials: TGetLicenseOverviewMaterials;
    successCallback?: (response: TLicenseOverviewResponse) => void;
    failedCallback?: (err: unknown) => void;
  };
};

export type TGetLicenseOverviewSuccess = {
  type: EGetLicenseOverviewAction.GET_LICENSE_OVERVIEW_SUCCESS;
  payload: { response: TLicenseOverviewResponse };
};

export type TGetLicenseOverviewFailed = { type: EGetLicenseOverviewAction.GET_LICENSE_OVERVIEW_FAILED };

// FUNCTION

export const getLicenseOverviewAction = {
  request: createActionCreator(
    EGetLicenseOverviewAction.GET_LICENSE_OVERVIEW_REQUEST,
    (resolve) =>
      (
        materials: TGetLicenseOverviewMaterials,
        successCallback?: (response: TLicenseOverviewResponse) => void,
        failedCallback?: (err: unknown) => void,
      ): TGetLicenseOverviewRequest =>
        resolve({ materials, successCallback, failedCallback }),
  ),
  success: createActionCreator(
    EGetLicenseOverviewAction.GET_LICENSE_OVERVIEW_SUCCESS,
    (resolve) =>
      (response: TLicenseOverviewResponse): TGetLicenseOverviewSuccess =>
        resolve({ response }),
  ),
  failure: createActionCreator(
    EGetLicenseOverviewAction.GET_LICENSE_OVERVIEW_FAILED,
    (resolve) =>
      (error: any): TGetLicenseOverviewFailed =>
        resolve({ error }),
  ),
};
